export type OfflinePaymentCreate = {
	paymentId: number;
	ticketExternalId: string;
	ticketId: number;
};

const model: types.models.InputModel = {
	ticketExternalId: 'response.ticketExternalId',
	ticketId: 'response.ticketId',
	paymentId: 'response.paymentId',
};

export default model;
